module.exports = __webpack_public_path__ + "media/images/shark/Fred-p-800-5ed8ae48045e7a0ff2a0a7d42d20f187.jpeg";